module.exports = __webpack_public_path__ + "static/media/pg.9b228e6c.svg";